import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tags", "checkbox", "dropdown"]

  connect() {
    this.isOpen = false
    this.updateTags()
  }

  clickOutsideHandler(e) {
    if (!this.element.contains(e.target)) {
      this.dropdownTarget.classList.remove("active")
      this.isOpen = false
    }
  }

  toggleDropdown() {
    this.dropdownTarget.classList.toggle("active", !this.isOpen)
    this.isOpen = !this.isOpen
  }

  toggle() {
    this.updateTags()
  }

  remove(e) {
    const value = e.currentTarget.dataset.value
    const checkbox = this.checkboxTargets.find(cb => cb.value === value)
    if (checkbox) {
      checkbox.checked = false
      this.updateTags()
    }
  }

  updateTags() {
    const selected = this.checkboxTargets.filter(cb => cb.checked)
    this.tagsTarget.innerHTML = selected.map(cb => this.buildTag(cb.value, cb.dataset.label)).join("")
  }

  buildTag(value, label) {
    return `
      <button type="button" class="inline-flex items-center gap-2 px-4 py-2.5 bg-neutral-0 rounded-[20px] text-grey-600 cursor-default whitespace-nowrap" data-action="click->sector-filter#remove" data-value="${value}">
        <span>${label}</span>
        <i class="far fa-times text-grey-400 hover:text-grey-600 cursor-pointer"></i>
      </button>
    `
  }
}
